export default {
  headerContent: {
    title: 'Türkiye Sigorta Konut (Ev) Sigortası Fiyatları',
    slogan: "Konut Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'KONUT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türkiye Sigorta Konut Sigortası',
    description: {
      title: 'Türkiye Sigorta Konut Sigortası (Ev Sigortası) Nedir? ',
      content: [
        'Türkiye Sigorta konut sigortası sigortalılarına sunmuş olduğu teminatlar ile sigortalılarını yangın, hırsızlık, yer kayması gibi hasarlara karşı koruma sunmaktadır.',
        'Türkiye Sigorta sağladığı koruma ile sigortalıları hasarların oluşması durumunda ortaya çıkan büyük maddi kayıplara güvence sağlar.'
      ]
    },
    subContent: {
      title: 'Türkiye Sigorta Konut Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: '',
          subList: [
            'Cam Kırılması',
            'Değerli Eşya Hırsızlık',
            'Deprem',
            'Diğer Yangın Ek Teminatları',
            'Dolu',
            'Elektronik Cihazlar',
            'Enkaz Kaldırma',
            'Ferdi Kaza',
            'Grev, Lokavt, Kargaşalık, Halk Hareketleri, Kötü Niyetli Hareketler, Terör',
            'Hırsızlık',
            'İkamet Değişikliği Masrafları',
            'Kapkaç',
            'Kira Kaybı',
            'Komşuluk, Kiracılık Mali Mesuliyet',
            'Konut Yardım',
            'Misafirlere Ait Eşyalar',
            'Taşınmaza Bağlı Hukuksal Koruma',
            'Yangın, Yıldırım, İnfilak'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Konut Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Konut Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Konut Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Konut Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türkiye Sigorta Konut Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Türkiye Sigorta Konut Sigortası Yardım Hizmetleri Nelerdir?',
      content: [
        {
          paragraph: '',
          subList: [
            'Konuta Ambulans Gönderilmesi',
            'Tesisat, Elektrik, Anahtar, Cam İşleri',
            'Kombi Klima Hizmeti',
            'Konutta Kalan Kişinin Kurtarılması',
            'Otel Hizmeti',
            'Güvenlik Şirketi',
            'Hastanede Yatma Durumunda Yardım',
            'Acil Mesajların İletilmesi',
            'Profesyonel Ev Hizmetleri Organizasyonu',
            'Bilgi Ve Organizasyon Servisi',
            'Hukuki Danışmanlık'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Paketleri Nelerdir?',
      content: [
        {
          paragraph: '',
          subList: [
            'Konut Ekstra Paket Sigortası',
            'Pratik Ev Sigortası'
          ]
        }
      ]
    },
    {
      title: 'Konut Ekstra Paket Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: '',
          subList: [
            'Yangın, Yıldırım, İnfilak',
            'Deprem Ve Yanardağ Püskürmesi',
            'Grev, Lokavt, Kargaşalık, Halk Hareketleri, Kötü Niyetli Hareketler, Terör',
            'Diğer Yangın Ek Teminatları',
            'Dolu',
            'Enkaz Kaldırma Masrafları',
            'Komşuluk, Kiracılık Mali Mesuliyet',
            'Hırsızlık',
            'Kira Kaybı, İkametgâh Değişikliği Masrafları',
            'Cam Kırılması',
            'Ferdi Kaza',
            'Taşınmaza Bağlı Hukuksal Koruma',
            'İzolasyon Hasarları',
            'Bina Demirbaş Koruma',
            'Bina Sabit Kıymet Hırsızlığı',
            'Nakit Para',
            'Boya Badana Masrafları',
            'Konut Dışında Bulunan Sigortalı Eşyalar',
            'Kapkaç',
            'Gıda Bozulması',
            'Elektronik Cihazlar',
            '3. Şahıs Mali Mesuliyet (Evcil Hayvanlar Dahil)',
            'Çevre Düzenlemesi',
            'Misafirlere Ait Eşyalar',
            'Akvaryum Teminatı',
            'Hasarlı Eşyaların Depolanması',
            'Garajdaki Araçlar ',
            'Değerli Eşya Hırsızlık'
          ]
        }
      ]
    },
    {
      title: 'Pratik Ev Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: '',
          subList: [
            'Yangın, Yıldırım, İnfilak',
            'Grev, Lokavt, Kargaşalık, Halk Hareketleri, Kötü Niyetli Hareketler Ve Terör',
            'Diğer Yangın Ek Teminatları',
            'Komşuluk/Kiracılık Mali Sorumluluk',
            'Enkaz Kaldırma',
            'Hırsızlık',
            'Cam Kırılması',
            'Taşınmaza Bağlı Hukuksal Koruma',
            'Üçüncü Şahıs Mali Sorumluluk',
            'Ferdi Kaza'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Kapsamı Nedir? Neleri Kapsar?',
      content: [
        {
          paragraph: 'Konut sigortası kapsamı almış olduğunuz teminatlara göre değişmektedir. Tercih edeceğiniz plana eklediğiniz teminatlar poliçe kapsamını belirler.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası İçin Gerekli Bilgiler Nelerdir?',
      content: [
        {
          paragraph: '',
          subList: [
            'Brüt metrekare',
            'Bulunduğu kat',
            'İnşa bedeli',
            'Kimlik bilgileri',
            'Konutun açık adresi',
            'Eşya bedeli gibi belge ve bilgilerdir.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası İle Dask Aynı Mı?',
      content: [
        {
          paragraph: 'Konut sigortası ile deprem sigortası farklıdır. Konut sigortası isteğe bağlı sigorta iken deprem sigortası kanunen zorunludur. Konut sigortası teminatları deprem sigortasına göre daha geniştir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Yaptırırken Nelere Dikkat Etmeliyiz?',
      content: [
        {
          paragraph: 'Konut sigortası alırken dikkat etmeniz gereken birkaç husus vardır.',
          subList: null
        },
        {
          paragraph: 'Bu hususlar;',
          subList: [
            'Konut sigortası konuta ve kişiye özel olarak düzenlenmektedir. Bu yüzden teklif üzerinde yazan adres bilgileri ve sigortalı bilgileri kontrol edilmelidir.',
            'Teklifte yazan teminatlar ve limitler kontrol edilmelidir.',
            'Poliçe üzerinde yer alan konut metrekare bilgisinin doğruluğu teyit edilmelidir.',
            'Tüm bunların dışında konut sigortası ile sunulan hizmetler hakkında bilgi alınmalıdır.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Deprem Hasarını Karşılar Mı?',
      content: [
        {
          paragraph: 'Konut sigortası teminatları arasında deprem teminatı bulunması ve deprem sigortası olması durumunda karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Yaptırmak Zorunlu Mu?',
      content: [
        {
          paragraph: 'Konut sigortası isteğe bağlı bir sigorta ürünüdür. Yaptırılması zorunlu değildir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Mobilya Mini Hasarlarını Kapsar Mı?',
      content: [
        {
          paragraph: 'Poliçe vadesi boyunca oluşan küçük çaplı mobilya hasarlarınız poliçe kapsamındadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Kira Kaybı Nedir?',
      content: [
        {
          paragraph: 'Kira kaybı, konutta her hangi bir riskten kaynaklı hasar oluşması sonucunda evin kullanamaz hale gelmesi sonucunda oluşacak kira kaybını karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Kiracı Tarafından Yaptırılabilir Mi?',
      content: [
        {
          paragraph: 'Kiracı tarafından içerisinde bulunan, eşyalarını güvence altına almak için konut sigortası yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Ödemesi Nasıl Yapılır?',
      content: [
        {
          paragraph: 'Konut sigortası ödemelerini kredi kartınızla yapabilirsiniz. Kredi kartınızla vadeli bir şekilde poliçe tanzimi yapabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph: 'Konut sigortası hesaplaması sigorta şirketlerinin belirlemiş olduğu kriterlere göre hesaplanmaktadır. Bu kriterler doğrultusunda sigortalıya ve konuta özel prim hesaplaması yapılır. Hesaplama işlemi gerekli bilgilerin sigorta şirketi ekranına girilmesi sonucunda belirlenir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Konut Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph: 'Konut sigortası fiyatları sigortalanacak konutun bedeli, eşya bedelleri ve aylık olarak değişmektedir. Bu bağlamda net bir konut sigortası fiyatı olmamaktadır. Gerekli bilgilerin girilmesi ile alacağınız teklif sonucunda fiyatları öğrenebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Online Konut Sigortası Nasıl Alınır?',
      content: [
        {
          paragraph: 'Online konut sigortası teklifi almak için sayfamızda bulunan konut sigortası formunu doldurmanız yeterlidir.',
          subList: null
        }
      ]
    }
  ]
}
